import { BaseModel } from "model/BaseModel";
import Deposito from "./Deposito";
import Produto from "model/administracao/cadastro/produto/Produto";


export default class EstoqueLote implements BaseModel {

    id: number;
    codigo: string | null;
    produto: Produto;
    deposito: Deposito;
    lote: string | null;
    quantidade: number;
    quantidadeEmprestada: number;
    quantidadeInutilizavel: number;
    validade: Date | null;
    ativo: boolean;


    constructor(
        id = 0,
        codigo = null,
        produto = new Produto(),
        deposito = new Deposito(),
        lote = null,
        quantidade = 0,
        quantidadeEmprestada = 0,
        quantidadeInutilizavel = 0,
        validade = null,
        ativo = true,
    ) {
        this.id = id;
        this.codigo = codigo;
        this.produto = produto;
        this.deposito = deposito;
        this.lote = lote;
        this.quantidade = quantidade;
        this.quantidadeEmprestada = quantidadeEmprestada;
        this.quantidadeInutilizavel = quantidadeInutilizavel;
        this.validade = validade;
        this.ativo = ativo;
    }
}
